import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
import type { ReactNode } from "react";

import { t } from "@/i18n-js/instance";
import { cssAnchorProps } from "@/react/helpers/cssAnchorHelpers";
import { useIsMemberAreaAppShellEnabled } from "@/react/hooks/useIsMemberAreaAppShellEnabled";

import { useSidebarCompassThemeVars } from "./useSidebarCompassThemeVars";

export interface SidebarLayoutProps {
  children: ReactNode;
  footer?: ReactNode;
}

export const SidebarLayout = ({ children, footer }: SidebarLayoutProps) => {
  const isMemberAreaAppShellEnabled = useIsMemberAreaAppShellEnabled();
  const sidebarThemeVars = useSidebarCompassThemeVars();

  return (
    <aside
      aria-label={t("left_sidebar")}
      className={classNames(
        // Dark surface is `bg-secondary`, which shares its grey with `--color-background-hover`,
        // so step hover up to primary. Custom themes override this token via inline style.
        "bg-primary dark:bg-secondary dark:[--color-background-hover:var(--color-background-primary)] flex flex-col h-full max-h-full",
        isMemberAreaAppShellEnabled ? "w-full" : "w-sidebar-v3 fixed",
      )}
      style={sidebarThemeVars}
      {...cssAnchorProps({ anchor: "app-sidebar" })}
    >
      <div className="min-h-0 flex-1">
        <OverlayScrollbarsComponent
          className="h-full"
          options={{
            scrollbars: {
              autoHide: "leave",
              autoHideDelay: 0,
            },
          }}
        >
          <div className="flex flex-col gap-4 px-3 py-5">{children}</div>
        </OverlayScrollbarsComponent>
      </div>
      {footer}
    </aside>
  );
};
